import './board-directory.scss';
import boardDirectoryData from './board-directory.json';

type BoardMember = {
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  organization: string;
  phone: string;
  email: string;
  website?: string;
};

type DirectorySection = {
  heading: string;
  members: BoardMember[];
};

type BoardDirectoryData = {
  documentTitle: string;
  sections: DirectorySection[];
};

const data = boardDirectoryData as BoardDirectoryData;

const normalizeWebsite = (url: string) =>
  url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;

const BoardDirectory = () => (
  <div className="board-directory-page">
    <section className="board-directory-hero">
      <div className="board-directory-hero__overlay" />
      <div className="board-directory-hero__content">
        <h1>Board Directory</h1>
        <p>- Serving Members -</p>
        <p>
          Leadership, Advisors, and Management Contacts for the Missouri
          Self-Insurers Association.
        </p>
      </div>
    </section>

    <section className="board-directory-details">
      <div className="board-directory-details__inner">
        <p className="board-directory-details__intro">{data.documentTitle}</p>

        <div className="board-directory-details__sections">
          {data.sections.map((section) => (
            <article key={section.heading} className="board-directory-details__section">
              <h2 className="board-directory-details__section-title">{section.heading}</h2>

              <div className="board-directory-details__members">
                {section.members.map((member) => (
                  <div
                    key={`${section.heading}-${member.firstName}-${member.lastName}`}
                    className="board-directory-details__member"
                  >
                    <p className="board-directory-details__role">{member.title}</p>
                    <h3 className="board-directory-details__name">
                      <span>
                        {member.firstName} {member.middleName && `${member.middleName} `}
                        {member.lastName}
                      </span>
                    </h3>
                    <p className="board-directory-details__organization">{member.organization}</p>

                    <p className="board-directory-details__meta">
                      <strong>Work:</strong> {member.phone}
                    </p>
                    <p className="board-directory-details__meta">
                      <strong>Email:</strong>{' '}
                      <a href={`mailto:${member.email}`}>{member.email}</a>
                    </p>
                    {member.website && (
                      <p className="board-directory-details__meta">
                        <strong>Website:</strong>{' '}
                        <a
                          href={normalizeWebsite(member.website)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {member.website}
                        </a>
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default BoardDirectory;
